import Suggestion from './Suggestion';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../../core/CancelButton';
import { globalStyles } from '../../core/style/gstheme';
import withGS from '../../core/withGShoc';

const styles = Object.assign({
}, globalStyles);

class SuggestionViewDialog extends React.Component {

    render() {

        const { classes, onHideSuggestion, id, schemeIRI, projectIRI, optionForXL, graph, isReadOnly, data, useXL, useCounterIRI, counters,useSlashIRI,
            components, useWorkflow, defaultLang, entitlements, iriOptions, user, users, resourceStatus } = this.props;

        const editable = !(data.deprecated || data.pendingDeletion || (data.inScheme && !data.inScheme.includes(schemeIRI)));

        return (
            <React.Fragment>
                <Dialog
                    data-test="suggestion-view-dialog"
                    maxWidth="xl"
                    fullWidth
                    className={classes.root}
                    classes={{
                        paperWidthXl: classes.xLargeDialog
                    }}
                    open={true}
                    aria-labelledby="suggestion-view-title">
                    <DialogTitle data-test="suggestion--viewtitle" disableTypography className={classes.mainHeading} id="text-dialog-title">Suggestion Detail</DialogTitle>
                    <DialogContent data-test="suggestion-view-dialog-content"
                        style={{
                            maxHeight: '500px'
                        }}>
                        <Suggestion
                            schemeIRI={schemeIRI}
                            expanded={true}
                            projectIRI={projectIRI}
                            components={components}
                            useWorkflow={useWorkflow}
                            useSlashIRI={useSlashIRI}
                            defaultLang={defaultLang}
                            onStatusChange={onHideSuggestion}
                            handleStatusChange={onHideSuggestion}
                            resourceStatus={resourceStatus ? resourceStatus[0] : null}
                            id={id}
                            optionForXL={optionForXL}
                            useXL={useXL}
                            useCounterIRI={useCounterIRI}
                            counters={counters}
                            iriOptions={iriOptions}
                            entitlements={entitlements}
                            graph={graph}
                            user={user}
                            isReadOnly={isReadOnly || data.pendingDeletion || !editable}
                            users={users} />
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={onHideSuggestion} >Close</CancelButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

SuggestionViewDialog.defaultProps = {
    useWorkflow: false
};

SuggestionViewDialog.propTypes = {
    schemeIRI: PropTypes.string,
    projectIRI: PropTypes.string.isRequired,
    optionForXL: PropTypes.bool,
    useXL: PropTypes.bool,
    useSlashIRI: PropTypes.bool,
    user: PropTypes.string.isRequired,
    users: PropTypes.array.isRequired,
    entitlements: PropTypes.array.isRequired,
    iriOptions: PropTypes.object,
    useWorkflow: PropTypes.bool,
    resourceStatus: PropTypes.array,
    useCounterIRI: PropTypes.bool,
    counter: PropTypes.object,
    defaultLang: PropTypes.string.isRequired,
    components: PropTypes.array.isRequired,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    onHideSuggestion: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(withGS(SuggestionViewDialog, ["ALL"], null, {}));